module.exports = __webpack_public_path__ + "img/how-01.e9c6dafe.svg";